import(/* webpackMode: "eager" */ "/vercel/path0/frontend/lesson-platform/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/lesson-platform/src/app/components/marketing/MarketingChrome.tsx");
